import moveRoutes from './routes'

/* @ngInject */
const moveCtrl = (
  $scope,
  toaster,
  $$wagon,
  $$railway,
  $$area,
  $$train,
  $state
) => {
  $scope.$$wagon = $$wagon
  $scope.$$train = $$train
  $scope.$$railway = $$railway
  $scope.$$area = $$area

  $scope.displayWaitingWagons = false

  $scope.goToSelectRailway = () => {
    $state.go(moveRoutes.selectRailway.path)
  }

  $scope.goToReport = () => {
    $state.go(moveRoutes.report.path)
  }

  $scope.goToSelectWagons = () => {
    $$wagon.data.myWagonIds.splice(0, $$wagon.data.myWagonIds.length)
    $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    $state.go(moveRoutes.selectWagons.path)
  }

  $scope.move = async (_wagonIds, _railwayId, _sens) => {
    try {
      const message = await $$wagon.request.move(_wagonIds, _railwayId, _sens)
      toaster.message(message)
      const railway = await $$railway.request.getById(_railwayId)
      $$railway.data.dest = railway
      $$railway.data.dest.myWagons = await $$wagon.request.getByRailway(railway.id)

      $scope.goToReport()
    } catch (error) {
      toaster.error(error)
    }
  }
}

export default moveCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/move/move.controller.js